import R from 'ramda';
import { createSelector } from 'reselect';
import { STATE_NAME } from '../constants';

const getPageInfo = createSelector(
  [R.path([STATE_NAME, 'pageInfo'])],
  pageInfo => {
    const { total, pages, limit } = pageInfo;

    return {
      ...pageInfo,
      ...(pages ? { total: Math.min(total, pages * limit) } : {}),
    };
  },
);

export default getPageInfo;
